// removed by extract-text-webpack-plugin
module.exports = {"component":"_1Grob7ZW-Gpoq4gx1nUeJ0","primary":"_1bnMmK9lk11UafeiQ-DelD","secondary":"_1bmoHMkSYMQi43Zvtqc9ZS","tertiary":"_1NjlSsNgiVpLLEcTh2tjtK","notes":"bxtBm9yr9lgClNzK04AEO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Appointments/AppointmentBody/AppointmentBodyContainer.css
// module id = 1402
// module chunks = 0